import { Button, Card, Dropdown, Menu } from "antd";
import { pathOr } from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";

import { setPopup } from "../../actions/popupAction";
import {
  LiveChatLogo,
  MenuIcon,
  PatientReport,
  SearchIconSmall,
  UploadFileIcon,
  nextgenWelcomeIcon,
  rcsIconMain,
} from "../../assets/svg";
import notificationSound from "../../assets/video/recieve_msg.mp3";
import ImportCSVModal from "../../components/csvModal";
import useWindowDimensions from "../../components/custom-hooks/useWindowDimensions";
import CustomButton from "../../components/customButton";
import Layout from "../../components/layout";
import MobileMenu from "../../components/mobileMenu";
import CustomNotification from "../../components/notification";
import {
  MOBILE_WIDTH,
  NEXTGEN_EHR_WHITELABEL,
  checkUrl,
  patientBulkUploadCSVSampleData,
  patientBulkUploadCommaSeparatedSampleData,
} from "../../constants/constants";
import welcomeChatIcon from "../../images/chat/welcome.png";
import { PatientCountAction } from "../../sagas/saga-actions";
import { downloadPatientFilesSagaAction } from "../../sagas/saga-fileDownload";
import CommonService from "../../service/CommonService";
import loginService from "../../service/login";
import Sound from "../../utilities/sound";
import Chat from "./components/chat/chat";
import PatientLookup from "./components/patientLookup";
import Sidenav from "./components/sidenav/sidenav";
import MobileHeader from "../../components/header/mobileHeader";
import "./styles.scss";

const commonService = new CommonService();
const AppForm = (props) => {
  const history = useHistory();
  const [enableNotification] = useState(
    !!props?.user?.liveChatNotifications || false
  );
  const { width } = useWindowDimensions();

  const isRcsEnableAccountLevel = loginService.getEnableRcs()

  const activePatientRef = useRef(null);
  activePatientRef.current = props?.activePatient?.activePatientList;

  const [state, setState] = useState({
    showChat: false,
    showDetails: false,
    toggleCSVModal: false,
    activeChatPatientNumber: "",
    notConfigured: true,
    otherStaffReload: false,
    chatSelected: null,
    viewDetails: false,
    transferNumberState: false,
    releaseNumberState: false,
    secureChat: false,
    selectedTagId: null,
  });
  const textInputRef = useRef();

  const handleChat = (value) => {
    setState((st) => ({
      ...st,
      showChat: value,
    }));
    if (textInputRef?.current?.innerHTML) {
      textInputRef.current.innerHTML = null;
    }
  };

  const _showChat = () => {
    handleChat(true);
  };

  const _hideChat = () => {
    handleChat(false);
  };

  useEffect(() => {
    if ("Notification" in window) {
      window.addEventListener(
        "receiveTextMessageFromSocket",
        (e) => {
          if (
            e.detail.msg.conversationType === "inbound" &&
            loginService.getToken()
          ) {
            if (
              document.visibilityState === "hidden" ||
              (document.visibilityState !== "hidden" &&
                history.location.pathname !== "/chat")
            ) {
              const activeArrayList = activePatientRef.current
                ? activePatientRef.current
                : [];

              const patientClaimedForUser = activeArrayList.find(
                (patient) => patient.id === e.detail.msg.patientId
              );
              const notificationSoundForUnclaimed = JSON.parse(
                localStorage.getItem("notificationSoundForUnclaimed")
              );
              if (
                (notificationSoundForUnclaimed && !patientClaimedForUser) ||
                patientClaimedForUser
              ) {
                sendNotification(true);
              }
              if (
                loginService.isLoggedin() &&
                e.detail.msg?.conversationType === "inbound" &&
                !e.detail.msg?.vacConversationId &&
                history?.location?.pathname !== "/chat"
              ) {
                if (
                  (notificationSoundForUnclaimed && !patientClaimedForUser) ||
                  patientClaimedForUser
                ) {
                  Sound.receive();
                }
              }
            }
          }
        },
        false
      );
    }

    async function fetchLivechatConfiguration() {
      const listResponse = await commonService.getLivechatConfiguration();
      localStorage.setItem(
        "notificationSoundForUnclaimed",
        listResponse?.notificationSoundForUnclaimed
      );
    }
    fetchLivechatConfiguration();
  }, []);

  const sendNotification = async (ignoreFocus) => {
    if (!ignoreFocus && document.hasFocus()) return;
    let permission = Notification.permission;
    const audio = new Audio(notificationSound);
    if (permission === "granted" && enableNotification) {
      const notification = new Notification("Housecalls Pro", {
        body: "New message received.",
        silent: false,
        icon: "https://thumbs.dreamstime.com/b/dreamstime-189051384.jpg",
      });
      // audio.loop = true;
      notification.onshow = () => {
        // only play sound for first notification
        if (audio.paused) audio.play();
      };
      notification.onclick = (e) => {
        audio.currentTime = 0;
        notification.close();
      };
    }
  };

  useEffect(() => {
    const {
      liveAgentAccess,
      liveChatAccess,
      broadcastAccess,
      reportOnlyAccess,
    } = loginService.getUser();
    if (!liveChatAccess) {
      if (reportOnlyAccess) {
        history.push("/chat/report");
      } else if (liveAgentAccess) {
        history.push("/chat-agent");
      } else if (broadcastAccess) {
        history.push("/broadcast");
      } else {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `You do not have access!`,
        });
        loginService.Logout();
        history.push("/");
      }
    } else {
      const checkToken = async () => {
        try {
          const livechatConfigurationExists = await commonService.fetchAppointmentData();

          if (!livechatConfigurationExists) {
            setState((st) => ({
              ...st,
              notConfigured: false,
              clickedSearch: false,
            }));
          }

          const livechatUser = loginService?.getDecodedToken()?.payload;

          if (!livechatUser.liveChatAccess) {
            checkUrl(livechatUser, history);
          }
        } catch (e) {
          console.log(e);
        }
      };
      checkToken();

      window.addEventListener("showChat", _showChat, false);
      window.addEventListener("hideChat", _hideChat, false);
      return () => {
        window.removeEventListener("showChat", _showChat);
        window.removeEventListener("hideChat", _hideChat);
      };
    }
  }, []);

  const showPatientLookup = () => {
    setState((st) => ({
      ...st,
      patientDrawer: true,
    }));
  };

  const showPatientReports = async () => {
    history.push("/chat/report");
  };

  const onClose = () => {
    setState((st) => ({
      ...st,
      patientDrawer: false,
    }));
  };

  const handleShowDetails = () => {
    setState((st) => ({ ...st, showDetails: !st.showDetails }));
  };

  const handleCSVModal = async (response, delimeter) => {
    const checkConnection = window.navigator.onLine ? "on" : "off";
    if (checkConnection === "off") {
      setState((st) => ({
        ...st,
        errorMessage: "You are offline, Please check your internet connection",
      }));
    } else {
      try {
        const data = new FormData();
        data.append("delimiter", delimeter);
        data.append("file", response[0].originFileObj);
        await commonService.uploadPatientCSV(data);

        const syncPatientCount = new CustomEvent("syncPatientCount", {});
        window.dispatchEvent(syncPatientCount);
        props.setPopup({
          customPopupMessage: true,
          message: "File has been uploaded",
          messageType: "success",
        });
      } catch (error) {
        props.setPopup({
          customPopupMessage: true,
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            error
          ),
          messageType: "error",
        });
        props.PatientCount();
      }
      setState((st) => ({ ...st, toggleCSVModal: false }));
    }
  };

  const getActivePatientNumber = (cellPhone) => {
    setState((st) => ({ ...st, activeChatPatientNumber: cellPhone }));
  };

  const handleStaffChange = () => {
    setState((st) => ({ ...st, otherStaffReload: !st.otherStaffReload }));
  };

  const handleDownloadReport = () => {
    setState((st) => ({ ...st, toggleCSVModal: true }));
  };

  const handleHideCsv = () => {
    setState((st) => ({ ...st, toggleCSVModal: false }));
  };

  const tabSet = localStorage.getItem("tabSet");

  const { customPopupMessage, messageType, message } = props.popupReducer;
  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={showPatientReports}>
        <span className="patient-menu-item">
          {PatientReport}
          Patient Report
        </span>
      </Menu.Item>
      {!state.notConfigured && (
        <Menu.Item key="1" onClick={handleDownloadReport}>
          <span className="patient-menu-item">
            {UploadFileIcon}
            Import
          </span>
        </Menu.Item>
      )}
    </Menu>
  );

  const transferNumber = () => {
    setState((st) => ({
      ...st,
      transferNumberState: true,
    }));
  };

  const releaseNumber = () => {
    setState((st) => ({
      ...st,
      releaseNumberState: true,
    }));
  };

  const getPatientDisplayDetails = () => {
    if (!state.chatSelected.firstName && !state.chatSelected.lastName) {
      return state.chatSelected.cellPhone;
    } else {
      return state.chatSelected.firstName + " " + state.chatSelected.lastName;
    }
  };
  const getSampleFileData = (fileType) => {
    return fileType === "txt"
      ? patientBulkUploadCSVSampleData
      : patientBulkUploadCommaSeparatedSampleData;
  };

  return (
    <>
      <Layout testId="live-chat-main-page-wrapper">
      <div className="display-in-mob">
        {!state.chatSelected && (
          <MobileHeader
            showLogo={true}
            showNotifications={true}
            showHelp={true}
            showAccountDetails={true}
            backgroundColor="black-bg"
          />
        )}
        {state.chatSelected && (
          <MobileHeader
            showLogo={false}
            showBackButton={true}
            showPageTitle={true}
            pageTitle={getPatientDisplayDetails()}
            showNotifications={false}
            showHelp={false}
            showAccountDetails={false}
            handleBackButton={() => {
              history.push("");
            }}
            showMenuIcon={tabSet === "activeItem" ? true : false}
            transferNumber={transferNumber}
            releaseNumber={releaseNumber}
            showSecureChat={state.secureChat}
          />
        )}
      </div>

      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      {state.patientDrawer && (
        <PatientLookup
          patientDrawer={state.patientDrawer}
          visible={state.patientDrawer}
          onClose={onClose}
        />
      )}
      {state.toggleCSVModal && (
        <ImportCSVModal
          visible={state.toggleCSVModal}
          handleCSVModal={handleCSVModal}
          hideCSVModal={handleHideCsv}
          listName="patients"
          outsideError={state.errorMessage}
          sampleFileData={getSampleFileData}
        />
      )}
      <div className="inner-content-wrapper mobile-view-livechat">
        <Card
          className="primary-card live-chat-card"
          title={
            <>
              <LiveChatLogo /> &nbsp; Live Chat{" "}
              { isRcsEnableAccountLevel && props?.user?.isRcsForLivechat  && (
                <span className="rcs-badge">
                  {rcsIconMain}
                  <span style={{ marginLeft: 4 }}>RCS Enabled</span>
                </span>
              )}
            </>
          }
          extra={
            <div className="extra-wrapper">
              <CustomButton
                title={
                  <>
                    {SearchIconSmall}
                    <span className="text">Patient Lookup</span>
                  </>
                }
                btntype="clear"
                onClick={showPatientLookup}
              />

              <Dropdown
                placement="bottomRight"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                overlay={menu}
                trigger={["click"]}
              >
                <Button
                  icon={<MenuIcon />}
                  className="patient-dropdown-button"
                />
              </Dropdown>
            </div>
          }
        >
          <div className="live-chat-content">
            {(width > MOBILE_WIDTH || !state.chatSelected) && (
              <Sidenav
                handleChat={handleChat}
                getActivePatientNumber={getActivePatientNumber}
                otherStaffReload={state.otherStaffReload}
                setChatState={setState}
                chatState={state}
                showPatientReport={showPatientReports}
                showPatientLookup={showPatientLookup}
                handleDownloadReport={handleDownloadReport}
                Sound={Sound}
              />
            )}

            {(width > MOBILE_WIDTH || state.chatSelected) && (
              <div className="chat-container">
                <If condition={state.showChat}>
                  <Then>
                    <Chat
                      Sound={Sound}
                      key={state.activeChatPatientNumber}
                      history={props.history}
                      showChat={state.showChat}
                      handleShowDetails={handleShowDetails}
                      activeChatPatientNumber={state.activeChatPatientNumber}
                      otherStaffReload={state.otherStaffReload}
                      handleStaffChange={handleStaffChange}
                      handleChat={handleChat}
                      textInputRef={textInputRef}
                      transferNumberState={state.transferNumberState}
                      setMainState={setState}
                      releaseNumberState={state.releaseNumberState}
                      selectedTagId={state.selectedTagId}
                    />
                  </Then>

                  <Else>
                    <div className="chat-welcome-message">
                      {NEXTGEN_EHR_WHITELABEL ? (
                        nextgenWelcomeIcon
                      ) : (
                        <img src={welcomeChatIcon} alt="" />
                      )}
                      <section className="content">
                        <p className="heading">Nothing to show</p>

                        <p className="message">
                          Please select active chats from the left panel and
                          start conversing.
                        </p>
                      </section>
                    </div>
                  </Else>
                </If>
              </div>
            )}
          </div>
        </Card>
      </div>
      {!state.chatSelected && <MobileMenu component="liveChat" />}
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  popupReducer: state.popupReducer,
  user: state.login.user,
  activePatient: state.activePatient,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
    downloadPatientFiles: (object, cb) => {
      dispatch(downloadPatientFilesSagaAction(object, cb));
    },
    PatientCount: bindActionCreators(PatientCountAction, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppForm);
